import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  CustomerTenderCancelReasonBean,
  CustomerTenderCancelReasonSearchCriteria,
  RestCustomerTenderCancelReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class CustomertenderCancelReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();

    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editCustomertenderCancelReason = (e, rowdata) => {
    if (e.detail === 1) this.props.editCustomertenderCancelReason(rowdata);
  };
  deleteCustomerTenderCancel = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteCustomerTenderCancel(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let customertenderCancelReason_list =
      this.props.customertenderCancelReason_list;
    let customertenderCancelReasonData =
      this.props.customertenderCancelReasonData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1.1">
              <FormLabel id="searchBarLabel">
                CustomertenderCancelReason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={customertenderCancelReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {customertenderCancelReason_list != null ? (
              <tbody>
                {customertenderCancelReason_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td className="td_attribute_width">
                      <Button
                        variant="secondry"
                        className="td_attribute_width"
                        onClick={(e) =>
                          this.editCustomertenderCancelReason(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>

                    <td> {Info.description}</td>

                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* {Info.isApplied == false ? ( */}
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteCustomerTenderCancel(e, Info.code)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                    {/* ) : (
                    <Button variant="secondry">
                      <CancelIcon />
                    </Button>
                  )} */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {customertenderCancelReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class CustomertenderCancelReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      customertenderCancelReasonData: this.props.customertenderCancelReasonData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  saveCustomertenderCancelReason = (e) => {
    this.props.saveCustomertenderCancelReason(
      this.state.customertenderCancelReasonData
    );
  };

  closeCustomertenderCancelReasonEntryForm() {
    this.props.closeCustomertenderCancelReasonEntryForm();
  }

  render() {
    let customertenderCancelReasonData =
      this.props.customertenderCancelReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={customertenderCancelReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter CustomertenderCancelReasonCode"
              onChange={this.onChange}
              value={customertenderCancelReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={customertenderCancelReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={customertenderCancelReasonData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class CustomertenderCancelReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      customertenderCancelReason_list: [],
      response: {},
      pageTitle: "Customer Tender Cancel Reason",
      customertenderCancelReasonData: new CustomerTenderCancelReasonBean(),
      pageList: new PageListBean(),
      criteria: new CustomerTenderCancelReasonSearchCriteria(),
      companyCode: "",

      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isCustomertenderCancelReasonListFormOpen: true,
      isCustomertenderCancelReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }
  moduleCaption = "Customer Tender Cancel Reason";
  cleardata = () => {
    let customertenderCancelReasonData = new CustomerTenderCancelReasonBean();
    customertenderCancelReasonData.companyCode = this.companyCode;
    this.setState({
      customertenderCancelReasonData: customertenderCancelReasonData,
    });
  };
  opentypeforms = () => {
    let customertenderCancelReasonData =
      this.state.customertenderCancelReasonData;
    this.editCustomertenderCancelReason(customertenderCancelReasonData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveCustomertenderCancelReasonResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeCustomertenderCancelReasonEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveCustomertenderCancelReason = (customertenderCancelReasonData) => {
    if (customertenderCancelReasonData.isFetched == true) {
      if (
        SecurityAccessManager.CustomerTenderCancelReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateCustomerTenderCancelReason(
          customertenderCancelReasonData,
          this.saveCustomertenderCancelReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CustomerTenderCancelReasonMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createCustomerTenderCancelReason(
          customertenderCancelReasonData,
          this.saveCustomertenderCancelReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editCustomertenderCancelReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.customerTenderCancelReason != null) {
        let customertenderCancelReasonData =
          response.data.customerTenderCancelReason;
        this.setState({
          customertenderCancelReasonData: customertenderCancelReasonData,
        });
        this.disable();
      }
    }
    this.openCustomertenderCancelReasonEntryForm();
  };

  editCustomertenderCancelReason = (customertenderCancelReasonCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customertenderCancelReasonCode;
    if (
      SecurityAccessManager.CustomerTenderCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readCustomerTenderCancelReason(
        readrestInput,
        this.editCustomertenderCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_customertenderCancelReasondata =
      this.state.customertenderCancelReasonData;
    temp_customertenderCancelReasondata[e.target.name] = e.target.value;
    this.setState({
      customertenderCancelReasonData: temp_customertenderCancelReasondata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let customertenderCancelReasonData =
      this.state.customertenderCancelReasonData;
    customertenderCancelReasonData.companyCode = this.companyCode;
    customertenderCancelReasonData.code =
      this.state.customertenderCancelReasonData.code.toUpperCase();
    this.clearError();
    this.saveCustomertenderCancelReason(customertenderCancelReasonData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeCustomertenderCancelReasonEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.clearErrors();
  };

  clearErrors = () => {
    let errList = [];
    this.setState({ error_list: errList });
  };

  openCustomertenderCancelReasonEntryForm = () => {
    this.setState({
      isCustomertenderCancelReasonListFormOpen: false,
      isCustomertenderCancelReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeCustomertenderCancelReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCustomertenderCancelReasonListFormOpen: true,
      isCustomertenderCancelReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadCustomertenderCancelReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerTenderCancelPageList != null
    ) {
      let customertenderCancelReasonList = new Array();
      if (
        !isEmptyArray(
          response.data.customerTenderCancelPageList
            .customerTenderCancelReasonBean
        )
      ) {
        customertenderCancelReasonList =
          response.data.customerTenderCancelPageList
            .customerTenderCancelReasonBean;
        customertenderCancelReasonList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.customerTenderCancelPageList.currentPage;
      pageList.pageSize = response.data.customerTenderCancelPageList.pageSize;
      pageList.totalCount =
        response.data.customerTenderCancelPageList.totalCount;
      this.setState({
        customertenderCancelReason_list: customertenderCancelReasonList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new CustomerTenderCancelReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCustomertenderCancelReasonPage(pageInput, criteria);
  };
  loadCustomertenderCancelReasonPage = (pageList, searchCriteria) => {
    let criteria = new CustomerTenderCancelReasonSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestCustomerTenderCancelReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.CustomerTenderCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getCustomertenderCancelReasonPageList(
        requestInput,
        this.loadCustomertenderCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  deleteCustomerTenderCancel = (code, rowData) => {
    //
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.customertenderCancelReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customertenderCancelReason_list: sorted });
    }
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isCustomertenderCancelReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isCustomertenderCancelReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isCustomertenderCancelReasonListFormOpen && (
          <CustomertenderCancelReasonListForm
            customertenderCancelReason_list={
              this.state.customertenderCancelReason_list
            }
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            customertenderCancelReasonData={
              this.state.customertenderCancelReasonData
            }
            editCustomertenderCancelReason={this.editCustomertenderCancelReason}
            deleteCustomerTenderCancel={this.deleteCustomerTenderCancel}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isCustomertenderCancelReasonListFormOpen && (
            <CustomertenderCancelReasonEntryForm
              customertenderCancelReasonData={
                this.state.customertenderCancelReasonData
              }
              closeCustomertenderCancelReasonEntryForm={
                this.closeCustomertenderCancelReasonEntryForm
              }
              saveCustomertenderCancelReason={
                this.saveCustomertenderCancelReason
              }
              editCustomertenderCancelReason={
                this.editCustomertenderCancelReason
              }
              onChange={this.onChange}
              isDisableFields={this.state.isDisableFields}
            />
          )}
      </div>
    );
  }
}

function CustomertenderCancelReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CustomertenderCancelReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CustomertenderCancelReasonAttributeModule;
